import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { Page } from '@/components/ui/page-layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useRequiredParams } from 'utils';
import { AccountHeader } from 'views/account/AccountHeader';
import { useAccount } from 'views/portfolio/account-queries';
import { PageSpinner } from 'widgets';

import { PolicyQueryError } from './investment-policy/PolicyQueryError';
import { ACCOUNT_PAGE_TABS, accountPageBase, matchAccountPageTab } from './useAccountPageView';

export const AccountPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const currentTab = matchAccountPageTab(location.pathname)?.value ?? ACCOUNT_PAGE_TABS[0].value;
    const { accountGUID } = useRequiredParams(['accountGUID']);
    const accountQuery = useAccount(accountGUID, { throwOnError: false });
    const { data: account, isPending } = accountQuery;

    if (isPending) return <PageSpinner />;
    if (accountQuery.isLoadingError) {
        return <PolicyQueryError message="Couldn’t load account information." queries={[accountQuery]} />;
    }
    if (!account) {
        return (
            <p role="status" className="text-cocoa-600 p-6">
                Account information is currently unavailable.
            </p>
        );
    }

    return (
        <Page>
            <div className="shrink-0">
                <AccountHeader showDetails />
            </div>
            <Tabs
                value={currentTab}
                onValueChange={(value) => navigate(`${accountPageBase(location.pathname)}/${value}`)}
                className="flex min-h-0 flex-1 flex-col"
            >
                <div className="flex-shrink-0 px-5 pt-3">
                    <TabsList>
                        {ACCOUNT_PAGE_TABS.map((tab) => (
                            <TabsTrigger key={tab.value} value={tab.value}>
                                {tab.label}
                            </TabsTrigger>
                        ))}
                    </TabsList>
                </div>
                <TabsContent value={currentTab} className="min-h-0 flex-1 overflow-auto px-5 pb-6">
                    <Outlet />
                </TabsContent>
            </Tabs>
        </Page>
    );
};
